import { ModuleUebersicht, type ModuleCfg } from './ModuleUebersicht';

const cfg: ModuleCfg = {
  path: 'montage',
  label: 'Montage',
  breadcrumb: 'Produktion',
  extraColumns: [
    { key: 'ral_farbe',        label: 'RAL' },
    { key: 'person_gefertigt', label: 'Gefertigt von' },
  ],
};

export function Montage() {
  return <ModuleUebersicht cfg={cfg} />;
}
